import React, { ReactNode } from 'react'
import { Badge } from '../../../../components/common/Badge'
import { getInterest } from '../../../../helpers/translations/interests'
import { useAppTranslation } from '../../../../hooks/useAppTranslation'
import { theme } from '../../../../theme/theme'
import { Interests } from '../../../../types/interests'
import { IAboutInfo } from '../../../../interfaces/models/users.interfaces'

interface UserInterestsProps {
  interests: IAboutInfo['interests'] | undefined
}

export const UserInterests = ({ interests }: UserInterestsProps): ReactNode => {
  const { translate } = useAppTranslation()

  if (!interests || interests.length === 0) {
    return null
  }

  return (
    <div className="flex flex-col space-y-3">
      <div className="flex items-center gap-3">
        <p className="text-neutral-30" style={theme.textVariants.caption}>
          {translate('userView.interestsTitle')}
        </p>
      </div>
      <div className="w-90 flex flex-row flex-wrap gap-3">
        {interests.map((interest) => (
          <Badge
            colorClass="bg-brandGreen/10"
            textColorClass="text-brandGreen"
            borderColorClass="border-brandGreen"
            key={interest}
            text={translate(getInterest(interest as Interests) as string)}
          />
        ))}
      </div>
    </div>
  )
}
